import React from 'react'

const VCTextSeparator = ({ title }) => (
  title !== undefined?
    <div className={`text-center${this.props.className?' '+this.props.className:''}`}>
      <hr />
        {title}
      <hr />
    </div>
  :
    <div>
      <hr />
    </div>
)

export default VCTextSeparator



// WEBPACK FOOTER //
// ./src/components/VCTextSeparator.js